import { render, staticRenderFns } from "./CascoAjanlatAdatokB10_V0.vue?vue&type=template&id=24146bc6&"
import script from "./CascoAjanlatAdatokB10_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB10_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports